namespace $.$$ {
	export class $shm_hitalama_map_editor extends $.$shm_hitalama_map_editor {
		
		title( next?: string ): string {
			return this.widget().title( next ) ?? ''
		}

		edit_page() {
			return this.widget() ? super.edit_page() : []
		}
		preview_page() {
			return (this.widget() || this.preview_widget()) ? super.preview_page() : []
		}

		tags( next?: readonly ( string )[] ): readonly ( string )[] {
			return this.widget().tags( next )
		}
		description( next?: string ): string {
			return this.widget().description( next ) ?? ''
		}

		@ $mol_mem
		used_tags( next?: string[] ): ( string )[] {
			return this.$.$shm_hitalama_profile.current()?.used_tags( next ) ?? []
		}

		@ $mol_mem_key
		Widget_preview( id: any ): $.$shm_hitalama_map_widget_any {
			return this.Widget(id)
		}

		Widget_content() {
			if( this.widget().type() == 'notebook' ) {
				return this.Widget( this.widget().link() ).Sub_hack( 'notebook_edit' ).Content_scroll()
			}
			return super.Widget_content()
		}

		widget_code_content() {
			return this.Code_editor().code_content()
		}

		Code_widget() {
			const widget = this.widget()
			if( widget.type() === 'autoview' ) return widget.code_widget() ?? widget.Use_text_from()?.remote() ?? widget
			return widget
		}

		Code_editor() {
			return this.Widget( this.Code_widget().link() ).Sub_hack( 'code' ) as $shm_hitalama_map_widget_float_code
		}

		code_no_crdt() {
			return this.Code_editor().no_crdt()
		}

		code_download_blob() {
			return this.Code_editor().code_download_blob()
		}

		code_download_file_name() {
			return this.Code_editor().code_download_file_name()
		}

		template_dictionary() {
			return this.Code_editor().template_dictionary()
		}

		template_selected( next?: string ) {
			return this.Code_editor().template_selected( next )
		}

		code_enabled( next?: boolean ) {
			return this.Code_editor().enabled( next )
		}

		run_click( next?: Event ) {
			if( next === undefined ) return null
			this.Code_editor().run_click()
			return next
		}

		Preview_widget() {
			const pinned = this.preview_widget()
			const ref = pinned ? this.map().widget( pinned ).link() : this.widget().link()
			const type = this.map().widget_by_link(ref).type()

			const view_widget = this.map().widget_by_link(ref).view_widget()
			if( view_widget ) {
				return this.Widget( view_widget.link() ).Sub()
			}

			const b = this.Widget( ref )
			if( [ 'code', 'code_js' ].includes(  type ) ) {
				return b.Sub_hack( 'autoview' )
			}

			if( type == 'notebook' ) {
				return b.Sub_hack( 'notebook_preview' )
			}

			return b.Sub()
		}

		Preview_content() {
			return this.Preview_widget().Content_scroll()
		}

		Preview_fullscreen() {
			return this.Preview_widget().Tools().Fullscreen()
		}
		
		cut_cancel() {
			this.cut_bubble_showed( false )
		}

		widget_cut() {
			this.map().widget_cut( this.widget().link() )
		}

		hide_head_tools( next?: boolean ) {
			return this.widget().hide_head_tools( next )
		}

		// controls() {
			// return this.Widget( this.widget().link() ).Sub().controls()
		// }

		Settings_pop() {
			return this.Widget( this.widget().link() ).Sub().Tools().Settings_pop()
		}

		widget_titles() {
			const list = this.map().Widgets_list()?.remote_list() ?? []
			const skip = [ 'code', 'code_js' ]
			return list.flatMap( ( b: $shm_hitalama_map_widget ) => skip.includes( b.type() ) ? [] : [b.title()] )
		}

		@ $mol_mem
		preview_widget( next?: string ) {
			if( next !== undefined ) {
				this.$.$mol_state_local.value( this.toString()+'preview', next )
				this.$.$mol_state_local.value<string>( this.toString()+'preview', next )
				return next
			}

			let preview = this.$.$mol_state_arg.value( 'preview' )
			if( preview ) {
				this.$.$mol_state_local.value( this.toString()+'preview', preview )
			}
			if( preview ) return preview!
			
			return this.$.$mol_state_local.value<string>( this.toString()+'preview' ) ?? ''
		}

		preview_head() {
			return [
				...this.preview_widget() ? [ this.Unpin() ] : [ this.Pin() ],
				this.Preview_reload(),
				this.Preview_fullscreen()
			]
		}

		preview_reload( next?: Event ) {
			if( next === undefined ) return null
			this.reload_view( this.Preview_widget() )
			return next
		}

		reload_view( view: any ) {
			if( view.reload_iframe ) return view.reload_iframe()
			view.run_click?.()
			view.View?.()?.run_click?.()
			view.result?.( null )
			view.Dom_wrapper?.( null )
			view.content?.( null )
			view.sub?.( null )
			view.dom_tree?.( null )
		}

		preview_unpin( next?: any ) {
			this.preview_widget('')
		}
		preview_pin( next?: any ) {
			this.preview_widget( this.widget().link().toString()! )
		}

	}
}
